module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/X-Men-Days-of-Future-Past.4636e50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/X-Men-Days-of-Future-Past.jpg
// module id = I7xV
// module chunks = 0